import { ObjectValues } from "types";

const QuestionOwnershipTerms = {
  SYNDICATED: "type_syndicated",
  CUSTOM: "type_custom",
  CIVICSCIENCE: "type_civicscience",
} as const;

export type QuestionOwnershipTerm = ObjectValues<typeof QuestionOwnershipTerms>;

export default QuestionOwnershipTerms;
